import I from '../types.ts';

const handlerMenu: I['handlerMenu'] = function (isShow) {
    const html = document.querySelector('html') as HTMLElement;

    html.classList[isShow ? 'add' : 'remove']('_hidden');

    this.setState({ menuShow: isShow });
};

export default handlerMenu;
